export const FINALIZE_SSO_URL_PARAM = 'finalizeSSOAuth';

export const FORCE_DISABLE_URL_PARAM = 'force-disable-sso';

export const FORCE_DISABLE_COOKIE_NAME = 'wt_force_disable_sso';

export const FORCE_DISABLE_COOKIE_EXPIRY = 1000 * 60 * 60; // 1 hour

export const SSO_PERSIST_TIER = 'sso-persist-tier';

export const AUTH_CALLBACK_PATH = '/account/callback';

export const API_ENDPOINTS_WITHOUT_AUTH = [
  '/api/v4/meta/compatibility-version',
];

export const API_ENDPOINTS_WITH_ID_TOKEN = ['/api/v4/auth/sync'];
